import { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';

// Contexts
import { withTranslate } from '../../../core/TenantProvider';
// Files in the same folder
import APSelectItemStyles from './styles/APSelectItem.style';
import CheckIconFilled from './assets/icons/check-icon-filled.svg';

interface APSelectItemProps extends WithStyles<typeof APSelectItemStyles> {
  displayName?: string;
  icon?: string;
  label: string;
  type?: string;
  translate: any;
  affiliateNumber?: string;
  'aria-selected'?: boolean;
}

class APSelectItem extends Component<APSelectItemProps, {}> {
  state = {
    image: ''
  };

  componentDidMount() {
    const {
      icon
    } = this.props;

    if (icon) {
      import(`./assets/${icon}.svg`).then(({ default: image }) => {
        this.setState({
          image
        });
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  renderLabel() {
    const { displayName, label } = this.props;

    return displayName || label;
  }

  renderIcon() {
    const { classes } = this.props;
    const { image } = this.state;

    return image && <img alt={`${this.renderLabel()}.svg`} className={classes.itemIcon} src={image} />;
  }

  renderAccountSelectLabel() {
    const { classes, translate, affiliateNumber } = this.props;

    return (
      <div className={classes.accountSelectLabelContainer}>
        <div className={classes.accountNameContainer}>{this.renderLabel()}</div>
        <div>{translate('account.section.accountswitch.selectoption.partneridtext')}{affiliateNumber}</div>
      </div>
    );
  }

  renderSelectedIndicatorIcon() {
    const { classes, 'aria-selected': ariaSelected } = this.props;
    return ariaSelected ? (
      <img alt="selected-option" src={CheckIconFilled} className={classes.selectedOptionTickIcon} />
    ) : (
      <div className={classes.unSelectedOptionCircle} />
    );
  }

  render() {
    const {
      classes,
      displayName,
      label,
      type
    } = this.props;

    const renderedLabel: string = displayName ? displayName : label;
    const isAccountSelectType: boolean = type === 'accountSelect';

    return (
      <li className={classes.itemContainer} {...this.props}>
        {this.renderIcon()}
        {isAccountSelectType ? this.renderAccountSelectLabel() : (
          <span className={classes.itemLabel} data-testid='list-item'>
            {renderedLabel}
          </span>
        )}
        {isAccountSelectType && this.renderSelectedIndicatorIcon()}
      </li>
    );
  }
}

export default withTranslate(withStyles(APSelectItemStyles)(APSelectItem));
